import axios from 'axios'
import { buildURL } from '../helper'
import apiConfig from '../../config/apiConfig'
import { getBpIdParam } from '../../common/helper'

const getFeedbackSurveyInfo = async () => {
  const bpIdParam = getBpIdParam()
  const { data } = await axios.get(
    `${buildURL('feedbackSurveyInfo', apiConfig.feedback)}${bpIdParam}`,
  )
  return data
}

export default getFeedbackSurveyInfo
